module.exports = __webpack_public_path__ + "static/img/the-boys2.5564b2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/the-boys2.jpg
// module id = G/br
// module chunks = 1